/* eslint-disable no-new */
import * as types from './mutation-define'
import axios from 'axios';
import msgpad_show from "../msgpad_show"

export function axios_get(url,{ commit, dispatch,state },{mutation,field},call_back){
	axios.get(url).then(resp=>{
  		if(resp.status ==200 ){
  			commit(mutation,resp.data[field]);
  		}else{
          msgpad_show("msgpad","失败",resp.data.err_msg,'error')
  		}
      if(call_back){
          call_back(null,resp);
      }
  	}).catch(function(err){
          msgpad_show("msgpad","NETWORK_ERROR",err.message,'error')
          if(call_back)
            call_back(err);
  	})
}
export function axios_post(url,data,{ commit, state },{mutation,field},call_back){
	axios.post(url,data).then(resp=>{
      debugger
  		if(resp.status ==200 ){
  			commit(mutation,resp.data[field]);
  		}else{
  			msgpad_show("msgpad","失败",resp.data.err_msg,'error')
  		}
      if(call_back){
        call_back(null,resp);
      }
  	}).catch(err=>{
  		  msgpad_show("msgpad","NETWORK_ERROR",err.message,'error')
        if(call_back)
            call_back(err);
  	})
}




// WEBPACK FOOTER //
// ./src/store/axios_operator.js